// Preserve native fetch before any wrappers (like Lovable's monitoring) can intercept it
// This MUST run at module initialization time, before any other code
const originalFetch = window.fetch.bind(window);

/**
 * Native fetch function that bypasses any wrappers (like Lovable's monitoring script)
 * Use this for Supabase operations to prevent DataCloneError in Lovable preview
 */
export const nativeFetch: typeof fetch = (...args) => {
  return originalFetch(...args);
};
